var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('user-form',{attrs:{"user":_vm.user,"title":"Nuevo productor"},on:{"submit":_vm.addUser}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }